import Overlay from 'Component/Overlay';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import ResetButton from 'Component/ResetButton';
import { lazy } from 'react';

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
));


import { CATEGORY_FILTER_OVERLAY_ID } from './CategoryFilterOverlay.config';

import { CategoryFilterOverlay as SourceCategoryFilterOverlay } from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.component';

export class CategoryFilterOverlay extends SourceCategoryFilterOverlay {
    renderHeading() {
        const { isContentFiltered } = this.props;

        return (
            <h3 block="CategoryFilterOverlay" elem="Heading" mods={{ isContentFiltered }}>
                {__('Filters')}
            </h3>
        );
    }

    renderEmptyFilters() {
        return (
            <>
                {this.renderNoResults()}
            </>
        );
    }

    renderSeeResults() {
        const { onSeeResultsClick, isContentFiltered, customFiltersValues } = this.props;

        return (
            <div
                block="CategoryFilterOverlay"
                elem="SeeResults"
            >
                <button
                    block="CategoryFilterOverlay"
                    elem="Button"
                    mix={{ block: 'Button' }}
                    onClick={onSeeResultsClick}
                    className={Object.keys(customFiltersValues).length > 1 ? 'active' : ''}
                >
                    {__('SEE RESULTS')}
                </button>
                {this.renderResetButton()}
            </div>
        );
    }

    renderDefaultFilters() {
        const {
            isMobile,
            activeStatus,
            onSeeResultsClick
        } = this.props;

        if (!isMobile) {
            return (
                <>
                    {this.renderFilters()}
                </>
            );
        }

        if (isMobile && activeStatus) {
            return (
                <>
                    <div className="CategoryFilterOverlay-Close" onClick={onSeeResultsClick}>
                        <UniversalIcon
                            src={media('close.svg', WYSIWYG_MEDIA)}
                            alt="closeIcon"
                            className="Image-Image"
                        />
                    </div>
                    {this.renderHeading()}
                    {this.renderFilters()}
                </>
            );
        }

        return (
            <>
                {this.renderHeading()}
                <div block="CategoryFilterOverlay" elem="ResetSection">
                    <div block="ResetAttributes">
                        {this.renderResetAttributes()}
                        {this.renderResetButton()}
                    </div>
                </div>
                {this.renderFilters()}
            </>
        );
    }

    renderResetButton() {
        const { onSeeResultsClick, customFiltersValues, availableFilters, toggleCustomFilter } = this.props;
        let pathname = window.location.pathname;
        if(pathname.includes('search')){
            if (Object.keys(customFiltersValues).length < 1)
                return null;
        }else {
            if (Object.keys(customFiltersValues).length < 2)
                return null;
        }

        return (
            <ResetButton
                onClick={onSeeResultsClick}
                mix={{ block: 'CategoryFilterOverlay', elem: 'ResetButton' }}
            />
        );
    }

    renderContent() {
        const {
            totalPages,
            areFiltersEmpty,
            isProductsLoading
        } = this.props;

        if (!isProductsLoading && totalPages === 0) {
            return this.renderEmptyFilters();
        }

        if (areFiltersEmpty) {
            return null
        }

        return (
            <>
                {this.renderDefaultFilters()}
            </>
        );
    }

    render() {
        const {
            onVisible,
            onHide,
            isCategoryAnchor,
            activeStatus,
        } = this.props;

        if (!isCategoryAnchor) {
            return (
                <div block="CategoryFilterOverlay" />
            );
        }

        if (!activeStatus) {
            return (
                <div block="CategoryFilterOverlay" elem="ResetSection">
                    {this.renderResetAttributes()}
                    {this.renderResetButton()}
                </div>
            );
        }

        return (
            <>
                <Overlay
                    onVisible={onVisible}
                    onHide={onHide}
                    mix={{ block: 'CategoryFilterOverlay' }}
                    id={CATEGORY_FILTER_OVERLAY_ID}
                    isRenderInPortal={false}
                >
                    <div block="CategoryFilterOverlay" elem="Wrapper">
                        {this.renderContent()}
                        {this.renderLoader()}
                    </div>
                </Overlay>
                {this.renderSeeResults()}
            </>
        );
    }
}

export default CategoryFilterOverlay;
